import { PropsWithChildren } from "react";

import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";

import { getReCaptchaKey } from "@/components/signup/utils";

export const SmartReCaptcha = ({ children }: PropsWithChildren) => {
    return (
        <GoogleReCaptchaProvider
            reCaptchaKey={getReCaptchaKey()}
            useEnterprise={true}
            useRecaptchaNet={true}
            scriptProps={{
                async: true
            }}
        >
            {children}
        </GoogleReCaptchaProvider>
    );
};
